import { z } from "zod";

import { FormField } from "../../../FormEngine/types";
import { multiSelectResponseSchema } from "../../common/schemaHelper";

/**
 * Mental Health History form schema
 *
 * This schema defines the fields for the Mental Health History form
 * using the FormEngine component.
 */
export const mentalHealthHistorySchema: FormField[] = [
  {
    type: "multi-select-response",
    name: "mentalHealthConcern",
    title: "Mental Health Concerns",
    description: "Have you ever been treated for any of the following?",
    options: [
      "Anxiety",
      "Depression",
      "Bipolar Disorder",
      "ADHD",
      "Suicidal Thoughts",
      "Suicidal Attempt",
      "Other",
    ].map((option) => ({ label: option, value: option })),
    schema: [
      {
        type: "input",
        name: "description",
        label: "Please describe",
      },
    ],
    fieldProps: {
      includeNoneOption: true,
    },
    rule: z
      .array(multiSelectResponseSchema)
      .min(1, { message: "Please select at least one option" }),
  },
  {
    type: "select",
    name: "motivationAndReadiness",
    title: "Motivation and Readiness",
    description: "How ready do you feel to make lifestyle changes to improve your health?",
    label: "Motivation and Readiness",
    fieldProps: {
      options: ["Very ready", "Somewhat ready", "Neutral or not sure yet", "Not ready"].map(
        (option) => ({ label: option, value: option }),
      ),
    },
  },
];

export default mentalHealthHistorySchema;
